module.exports = __webpack_public_path__ + "assets/surfaces.85c1a71d.svg";